var _g, _circle, _path, _path2, _circle2, _circle3, _circle4, _circle5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallBlindCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2713_5450)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 9,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 5.34375,
    fill: "white",
    stroke: "#7C5DD7",
    strokeWidth: 0.5625
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3061 7.81531L19.4393 5.93307C19.1308 5.48093 18.7821 5.05837 18.3984 4.67051L18.3296 4.60172C17.9416 4.2179 17.5189 3.86912 17.0666 3.5605L15.1844 5.69369C16.0534 6.21631 16.7834 6.94635 17.3061 7.81531ZM17.306 14.1847C16.7833 15.0537 16.0533 15.7837 15.1843 16.3063L17.0665 18.4395C17.5223 18.1286 17.948 17.7768 18.3383 17.3895L18.3896 17.3382C18.7768 16.948 19.1284 16.5225 19.4392 16.067L17.306 14.1847ZM8.81535 16.306C7.9464 15.7834 7.21636 15.0533 6.69375 14.1843L4.56061 16.0665C5.19609 16.9978 6.00188 17.8037 6.93316 18.4392L8.81535 16.306ZM6.69366 7.81569C7.21626 6.9467 7.94628 6.21661 8.81522 5.69393L6.93307 3.56083C6.0018 4.19637 5.19602 5.00221 4.56055 5.93353L6.69366 7.81569Z",
    fill: "#7C5DD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 11C15.375 12.864 13.864 14.375 12 14.375C10.136 14.375 8.625 12.864 8.625 11C8.625 9.13604 10.136 7.625 12 7.625C13.864 7.625 15.375 9.13604 15.375 11Z",
    fill: "#7C5DD7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3.6875,
    r: 0.5625,
    fill: "#7C5DD7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18.3125,
    r: 0.5625,
    fill: "#7C5DD7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 11,
    r: 0.5625,
    fill: "#7C5DD7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.6875,
    cy: 11,
    r: 0.5625,
    fill: "#7C5DD7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2713_5450",
    x: 0.75,
    y: 0.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2713_5450"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2713_5450",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallBlindCoin);
export default __webpack_public_path__ + "static/media/small-blind-coin.f8b7a6de36f92492bb092ba0c8b5f529.svg";
export { ForwardRef as ReactComponent };